import React from 'react';

const Error = () => {

    const baseUrl = document.getElementById('baseFullPath').getAttribute('href');

    const params = new URLSearchParams(window.location.search)
    let Mensaje = '';

    if (params.get('Mensaje') !== null) {
        Mensaje = params.get('Mensaje');
     }

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="alert alert-danger">
                                <div className="text-center my-alert mt-3" role="alert">
                                    <h3><i className="fas fa-exclamation-circle mr-2"></i>{Mensaje !== '' ? Mensaje : 'No es posible visualizar los datos'}</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="m-auto">
                                    <img src={`${baseUrl}Public/img/error.png`} className="img-fluid center-block" alt='No es posible visualizar los datos' />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div >
    );

}
export default Error;